import React, { useState, useEffect } from 'react';
import { Table, Button, Space, message, Input, Select } from 'antd';
import useWebPost from '../../utils/useWebPost';
import FullHeightLayout from '../../components/FullHeightLayout';
import { checkp, confirmBox, exportToCSV, formatNumber } from '../../utils/functions';

function Hggys() {
    const webPost = useWebPost();
    const [data, setData] = useState([]);
    const [kw, setKw] = useState({xm:'',ph:'',fw:''});
    const [total, setTotal] = useState(-1);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [fkey, setFkey] = useState(0);
    const [loading, setLoading] = useState(false);

    const pageSizeOptions = [10, 20, 100, 200, 500];
    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            const params = { page: currentPage, limit: pageSize, ...kw };
            try {
                const response = await webPost('hggyslist', params);
                if (response && response.data) {
                    setData(response.data);
                    setTotal(response.total);
                } else {
                    setData([]);
                    setTotal(0);
                }
            } catch (error) {
                console.error('获取列表失败:', error);
                message.error('请求失败，请稍后重试');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        return undefined;
    }, [currentPage, pageSize, fkey]);

    const columns = [
        {
            title: '序号', dataIndex: 'xd', width: 80,
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '单位名称', dataIndex: 'gys_name', width: 120 },
        { title: '税号', dataIndex: 'gys_tax', width: 200, },
        { title: '单位地址', dataIndex: 'gys_addr', width: 120 },
        { title: '联系人/电话', dataIndex: 'gys_phone', width: 80 },
        { title: '主营范围', dataIndex: 'gys_yyfw', width: 120 },
        checkp('all') && { title: '操作', dataIndex: 'ops', width: 120, render:(t,rs)=>(
            <Button onClick={()=>{
                cancelZg(rs);
            }}>取消资格</Button>
        ) },
    ].filter(Boolean);
    function cancelZg(rs){
        confirmBox(async ()=>{
            const res = await webPost('cancel_gyszg',{a: rs.gys_name, b: rs.gys_tax});
            if(res){
                message.success('取消成功');
                const newData = data.filter(item => item !== rs);
                setData(newData);
            }
        },null,'取消合格供应商资格')
    }
    return (
        <FullHeightLayout
            headerContent={
                <Space className='mtb12x'>
                    <Input placeholder='单位名称' onChange={(e) => setKw(prev => ({ ...prev, xm: e.target.value }))} />
                    <Input placeholder='联系人/电话' onChange={(e) => setKw(prev => ({ ...prev, ph: e.target.value }))} />
                    <Input placeholder='主营范围' onChange={(e) => setKw(prev => ({ ...prev, fw: e.target.value }))} />
                    <Button onClick={() => { setFkey(Math.random()) }}>搜索</Button>
                    <Button style={{ margin: '0 10px', position:'absolute', right:'10px', top:'10px' }} type="dashed" onClick={() => exportToCSV(data, columns.splice(1), '合格供应商_共'+total+'_'+
                        (pageSize*(currentPage -1 ) + '-' + pageSize*(currentPage)))}>
                        下载本页数据
                    </Button>
                </Space>
            }
            bodyContent={
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    loading={loading}
                    pagination={{ pageSize: pageSize, total: total, showSizeChanger: true, pageSizeOptions:pageSizeOptions }}
                    onChange={(e) => {
                        setCurrentPage(e.current);
                        if (e.pageSize !== pageSize) {
                            setPageSize(e.pageSize);
                        }
                    }}
                />
            }
        />


    );
}

export default Hggys;
